import Vue from 'vue'
import { dateTimeLocalString } from '@/util'

Vue.filter('date', function (date) {
  const str = dateTimeLocalString(date)
  return str
    ? str.substring(0, 10)
    : '-'
})

Vue.filter('datetime', (date) => {
  const str = dateTimeLocalString(date)
  if (str) {
    const d = str.substring(0, 10)
    const t = str.substring(11, 17)
    return d + ' / ' + t
  }
  return '-'
})

Vue.filter('floor', function (value) {
  if (value === null) {
    return '-'
  }
  return Math.floor(value)
})

Vue.filter('srtstr', function (value) {
  return value.length > 45
    ? `${value.substring(0, 45)}...`
    : value
})

Vue.filter('liststr', function (value, field = 'name') {
  let result = ''
  for (const item of value) {
    result += `${item[field]}, `
  }
  return result.substring(0, result.length - 2)
})

Vue.filter('shortstr', function (value) {
  return value.length > 25
    ? `${value.substring(0, 25)}...`
    : value
})

Vue.filter('kgtotn', (value) => {
  return Math.round(value / 1000)
})

Vue.filter('rounding', (value) => {
  return Math.floor((Math.floor(value * 1000) / 10)) / 100
})

Vue.filter('sectomin', (value) => {
  if (value === null) {
    return 0
  }
  return Math.floor(value / 6) / 10
})
